module.exports = "/assets/efd07c8a7ac644dec10ccf12f472928f.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/IV.png
// module id = 1488
// module chunks = 0